import Logo_seller from "../../assets/Images/logo_seller.webp";
import Logo_seller_2 from "../../assets/Images/logo_seller_2.webp";
import Logo_seller_3 from "../../assets/Images/logo_seller_3.webp";
import Logo_seller_4 from "../../assets/Images/logo_seller_4.webp";

export const DataSeller = [
  {
    logo: Logo_seller,
    nom: "Mongo_DB",
    site: "www.mongodb.com",
    telephone: "+229 01 26 27 75 89",
    email: "mongoDb@gmail.com",
    localisation:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15861.387310732007!2d2.3714911999999995!3d6.3491199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1023542ed5853b5b%3A0xcf0ca2400e6934f!2sLe%20Code%20Bar!5e0!3m2!1sfr!2sbj!4v1757939357422!5m2!1sfr!2sbj",
    adresse: "Rue 230, Cotonou 992P+MM Cotonou",
    nombre_commande: "228",
    revenu: "45 000",
    notation: "3",
    category: "Produits Locaux",
    epicerie: "0",
    produits_locaux: "80",
    electronic: "0",
    boissons: "20",
  },
  {
    logo: Logo_seller_2,
    nom: "Mongo_DB",
    site: "www.mongodb.com",
    telephone: "+229 01 26 27 75 89",
    email: "mongoDb@gmail.com",
    localisation:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15861.387310732007!2d2.3714911999999995!3d6.3491199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1023542ed5853b5b%3A0xcf0ca2400e6934f!2sLe%20Code%20Bar!5e0!3m2!1sfr!2sbj!4v1757939357422!5m2!1sfr!2sbj",
    adresse: "Rue 230, Cotonou 992P+MM Cotonou",
    nombre_commande: "228",
    revenu: "45 000",
    notation: "3",
    category: "Produits Locaux",
    epicerie: "0",
    produits_locaux: "80",
    electronic: "0",
    boissons: "20",
  },
  {
    logo: Logo_seller_3,
    nom: "Mongo_DB",
    site: "www.mongodb.com",
    telephone: "+229 01 26 27 75 89",
    email: "mongoDb@gmail.com",
    localisation:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15861.387310732007!2d2.3714911999999995!3d6.3491199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1023542ed5853b5b%3A0xcf0ca2400e6934f!2sLe%20Code%20Bar!5e0!3m2!1sfr!2sbj!4v1757939357422!5m2!1sfr!2sbj",
    adresse: "Rue 230, Cotonou 992P+MM Cotonou",
    nombre_commande: "228",
    revenu: "45 000",
    notation: "3",
    category: "Produits Locaux",
    epicerie: "0",
    produits_locaux: "80",
    electronic: "0",
    boissons: "20",
  },
  {
    logo: Logo_seller_4,
    nom: "Mongo_DB",
    site: "www.mongodb.com",
    telephone: "+229 01 26 27 75 89",
    email: "mongoDb@gmail.com",
    localisation:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15861.387310732007!2d2.3714911999999995!3d6.3491199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1023542ed5853b5b%3A0xcf0ca2400e6934f!2sLe%20Code%20Bar!5e0!3m2!1sfr!2sbj!4v1757939357422!5m2!1sfr!2sbj",
    adresse: "Rue 230, Cotonou 992P+MM Cotonou",
    nombre_commande: "228",
    revenu: "45 000",
    notation: "3",
    category: "Produits Locaux",
    epicerie: "0",
    produits_locaux: "80",
    electronic: "0",
    boissons: "20",
  },
  {
    logo: Logo_seller,
    nom: "Mongo_DB",
    site: "www.mongodb.com",
    telephone: "+229 01 26 27 75 89",
    email: "mongoDb@gmail.com",
    localisation:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15861.387310732007!2d2.3714911999999995!3d6.3491199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1023542ed5853b5b%3A0xcf0ca2400e6934f!2sLe%20Code%20Bar!5e0!3m2!1sfr!2sbj!4v1757939357422!5m2!1sfr!2sbj",
    adresse: "Rue 230, Cotonou 992P+MM Cotonou",
    nombre_commande: "228",
    revenu: "45 000",
    notation: "3",
    category: "Produits Locaux",
    epicerie: "0",
    produits_locaux: "80",
    electronic: "0",
    boissons: "20",
  },
  {
    logo: Logo_seller,
    nom: "Mongo_DB",
    site: "www.mongodb.com",
    telephone: "+229 01 26 27 75 89",
    email: "mongoDb@gmail.com",
    localisation:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15861.387310732007!2d2.3714911999999995!3d6.3491199!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1023542ed5853b5b%3A0xcf0ca2400e6934f!2sLe%20Code%20Bar!5e0!3m2!1sfr!2sbj!4v1757939357422!5m2!1sfr!2sbj",
    adresse: "Rue 230, Cotonou 992P+MM Cotonou",
    nombre_commande: "228",
    revenu: "45 000",
    notation: "3",
    category: "Produits Locaux",
    epicerie: "0",
    produits_locaux: "80",
    electronic: "0",
    boissons: "20",
  },
];
